export default __webpack_public_path__ + "static/media/tick-accent.2d851d5e.svg";